import { Text } from '@bbl-digital/snorre'
import { RelationPicker, SimpleClient } from '@bbl-digital/snorre-v2'
import { FC } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { setClientById } from 'shared/store/clients/actions'
import { getActiveClient, getClients } from 'shared/store/clients/selectors'

const MobileContextMenu: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const dispatch = useDispatch()
  const { push } = useHistory()

  const activeClient = useSelector(getActiveClient)
  const clients = useSelector(getClients)

  const handleSetClient = (selected: SimpleClient) => {
    if (!activeClient) return
    if (selected.id === activeClient?.id) return

    dispatch(setClientById(selected.id))
    push('/')
    onClose?.()
  }

  return (
    <div className="flex flex-col items-center justify-center w-[90%] p-md mt-md gap-md">
      <RelationPicker
        dark
        currentClient={{
          id: activeClient?.id,
          name: activeClient?.clientName,
          sortKey: activeClient?.sortKey,
          no: activeClient?.no,
        }}
        clients={clients}
        onSelect={handleSetClient}
      />
      <Text size="10px" align="center" color="white">
        © BBL Pivotal. Versjon 2.0.1
      </Text>
    </div>
  )
}

export default MobileContextMenu
